import { render, staticRenderFns } from "./competitionList.vue?vue&type=template&id=34509f8c"
import script from "./competitionList.vue?vue&type=script&lang=js"
export * from "./competitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports